module.exports = __webpack_public_path__ + "static/27-3ab4aa9246e9c53cb4e1ddc62d062d1b.png";